import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/base/property/bill/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/base/property/bill/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/base/property/bill/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/base/property/bill/save', params,options)

export const update = (params, options) =>
request.post('/api/base/property/bill/submit', params,options)
